<template>
  <div class="player-badge">
    <div class="title" :class="{off:!isOn}">{{(player.title || player.pin)}}</div>
    <div class="online-indicator" :class="{online:isOn}"></div>
    <div v-if="isBusy && !noThumb" class="thumbnail" :class="{'no-image':!thumbnailUrl}" :style="{backgroundImage:`url(${thumbnailUrl})`}"></div>
  </div>
</template>

<script>
import { Artwork } from '../../models/ArtworkData'
import { mapState } from 'vuex'

export default {
  name: 'player-badge',
  props: {
    /** @type Player */
    player: { type: Object, required: true },
    noThumb: Boolean
  },

  computed: {
    ...mapState(['accountArtworks']),
    isOn () {
      return this.player.connected
    },
    isBusy () {
      return !!this.player.artwork
    },
    thumbnailUrl () {
      if (!this.player.artwork) return ''
      const artwork = this.artworks.find(w => w.key === this.player.artwork.key)
      return artwork ? artwork.thumbnailUrl() : ''
    },
    artworks () {
      if (this.accountArtworks) {
        return this.accountArtworks.map(it => Artwork.fromJson(it))
      }
      return []
    }
  },

  methods: {}
}
</script>

<style lang="scss">
  @import "../../scss/vars";
  @import "../../scss/mixins";

  .dark{
    .player-badge{
      .title.off{
          color: darken($px-color-grey, 20%);
      }
      .online-indicator{
        background: darken($px-color-grey, 8%);
      }
    }
  }
  .player-badge {
    $size: $two-thirds;

    display: flex;
    align-items: center;

    &>*:not(:last-child){
      margin-right: $basic-padding / 2;
    }

    .title{
      &.off{
        color: $px-color-grey;
      }
    }
    .online-indicator{
      position: relative;
      width: 20px;
      height: 20px;
      background: $px-color-grey;
      border-radius: 10px;

      &:after{
        content: 'OFF';
        color: darken($px-color-grey, 40%);
        font-size: 8px;
        font-weight: 400;
        @include centered;
      }

      &.online{
        background: $px-color-green;
        &:after{
          content: 'ON';
        }
      }
    }

    .thumbnail{
      width: $basic-size;
      height: $basic-size * 0.5625;
      //border-radius: $size / 2;
    }
  }
</style>
